export default __webpack_public_path__ + "static/media/banner.1f050d53.svg";